







































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop, Watch } from 'vue-property-decorator';
import EsConfForm from './es-conf-form.vue';
import DsConfForm from './ds-conf-form.vue';
import FileConfForm from './file-conf-form.vue';
import KafkaConfForm from './kafka-conf-form.vue';
import HiveConfForm from './hive-conf-form.vue';
import DorisConfForm from './doris-conf-form.vue';

@Component({
  components: { EsConfForm, DsConfForm, FileConfForm, KafkaConfForm, HiveConfForm, DorisConfForm }
})
export default class DatasourceFormTab2 extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;
  @Prop() id!: any;
}
